import { Box, Loader, Stack, Text } from '@mantine/core';

type LoaderStateProps = {
  label?: string;
  py?: number | string;
};

export const LoaderState = ({
  label = 'Loading',
  py = 80,
}: LoaderStateProps) => {
  return (
    <Box py={py}>
      <Stack align="center" spacing="md">
        <Loader size="lg" />
        <Text size="sm" c="dimmed">
          {label}
        </Text>
      </Stack>
    </Box>
  );
};
